// Utils
import { parseColorStrToRGBA } from 'color-utils';
import { getAttributeData } from './brandingUtil';
import { getColorCSSVar } from './getCSSVarUtil';

// Constants
import BRANDING from '../constants/brandingConst';
import BRANDING_KEYS from '../constants/brandingKeysConst';
import BRANDING_CSS_VARS from '../constants/brandingCSSVarsConst';

const getWidgetHeaderTheme = (attributes) => {
    const { WIDGETS_HEADER_BG_COLOR, WIDGETS_HEADER_TEXT_COLOR } = BRANDING;

    return {
        ...getColorCSSVar(
            attributes,
            WIDGETS_HEADER_BG_COLOR,
            BRANDING_CSS_VARS[WIDGETS_HEADER_BG_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            WIDGETS_HEADER_TEXT_COLOR,
            BRANDING_CSS_VARS[WIDGETS_HEADER_TEXT_COLOR],
        ),
    };
};

const getWidgetBorderTheme = (attributes) => {
    const {
        WIDGETS_BORDER_COLOR,
        WIDGETS_BORDER_RADIUS,
        WIDGETS_BORDER_WIDTH,
    } = BRANDING;
    const variables = {
        ...getColorCSSVar(
            attributes,
            WIDGETS_BORDER_COLOR,
            BRANDING_CSS_VARS[WIDGETS_BORDER_COLOR],
        ),
    };

    // Get Border Radius
    const { value: borderRadius } = getAttributeData(
        attributes,
        BRANDING_KEYS[WIDGETS_BORDER_RADIUS],
    );

    if (borderRadius !== undefined) {
        const noPx = borderRadius === 0;
        // Set Border Radius Variable
        variables[BRANDING_CSS_VARS[WIDGETS_BORDER_RADIUS]] = `${borderRadius}${
            noPx ? '' : 'px'
        }`;
    }

    // Get Border Width
    const { value: borderWidth } = getAttributeData(
        attributes,
        BRANDING_KEYS[WIDGETS_BORDER_WIDTH],
    );

    if (borderWidth !== undefined) {
        const noPx = borderWidth === 0;
        // Set Border Width Variable
        variables[BRANDING_CSS_VARS[WIDGETS_BORDER_WIDTH]] = `${borderWidth}${
            noPx ? '' : 'px'
        }`;
    }

    return variables;
};

const getWidgetBodyTheme = (attributes) => {
    const {
        WIDGETS_BG_OPACITY,
        WIDGETS_DROP_SHADOW,
        WIDGETS_HAS_DROP_SHADOW,
    } = BRANDING;
    const variables = {};

    // Get Has Drop Shadow
    const { value: hasDropShadow } = getAttributeData(
        attributes,
        BRANDING_KEYS[WIDGETS_HAS_DROP_SHADOW],
    );
    const dropShadowVal = hasDropShadow
        ? 'var(--widget-box-shadow-val)'
        : 'none';
    variables[BRANDING_CSS_VARS[WIDGETS_DROP_SHADOW]] = dropShadowVal;

    // Get Opacity
    const { value: opacity } = getAttributeData(
        attributes,
        BRANDING_KEYS[WIDGETS_BG_OPACITY],
    );

    if (opacity !== undefined) {
        // Set Text Color Variable
        variables[BRANDING_CSS_VARS[WIDGETS_BG_OPACITY]] = opacity / 100;
    }

    return variables;
};

const getWidgetMiscTheme = (attributes) => {
    const { WIDGETS_HEADER_BG_COLOR } = BRANDING;
    const variables = {};

    // Get BG Color
    const { value: bgColor } = getAttributeData(
        attributes,
        BRANDING_KEYS[WIDGETS_HEADER_BG_COLOR],
    );

    if (bgColor) {
        // Get RGB of background color
        const { r, g, b } = parseColorStrToRGBA(bgColor);
        // const color = Color({ r, g, b });

        // Set RGB at 10% Opacity Variable
        variables['--widget-header-bg-color-rgba-10p'] = `rgba(${Math.round(
            r,
        )}, ${Math.round(g)}, ${Math.round(b)}, 0.1)`;

        // Set RGB at 50% Opacity Variable
        variables['--widget-header-bg-color-rgba-50p'] = `rgba(${Math.round(
            r,
        )}, ${Math.round(g)}, ${Math.round(b)}, 0.5)`;
    }

    return variables;
};

const widgetThemeUtil = (attributes) => {
    return {
        ...getWidgetHeaderTheme(attributes),
        ...getWidgetBorderTheme(attributes),
        ...getWidgetBodyTheme(attributes),
        ...getWidgetMiscTheme(attributes),
    };
};

export default widgetThemeUtil;
